import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { ChallengeFocusScoreEntity } from '../../entities/challenge-insights/challenge-focus-score.entity';
import { MetricValueType } from '../../../../interface/dtos/challenge-insights/metric-value-type';
import { ChallengeTargetOperatorEnum } from '../../../../common/enum/challenge-target/challenge-target-operator.enum';

export interface ChallengeInsightProgressFocusV1SummaryAggregateRootProps {
  entity: ChallengeFocusScoreEntity;
  currentDayEntity: ChallengeFocusScoreEntity;
  targetValue: number;
  type: MetricValueType;
}

export class ChallengeInsightProgressFocusV1SummaryAggregateRoot extends Entity<ChallengeInsightProgressFocusV1SummaryAggregateRootProps> {
  protected _id: string;
  protected _successPercentage: number;
  protected _operator: ChallengeTargetOperatorEnum;
  static create(
    props: ChallengeInsightProgressFocusV1SummaryAggregateRootProps,
    entityId?: string
  ): ChallengeInsightProgressFocusV1SummaryAggregateRoot {
    const id = entityId || v4();
    const entity = new ChallengeInsightProgressFocusV1SummaryAggregateRoot({
      id,
      props,
    });
    return entity;
  }
  public validate(): void {}

  get type(): MetricValueType {
    return this.props.type;
  }

  get count(): number {
    return this.props.entity.count;
  }
  get value(): number {
    return this.props.entity.value;
  }
  get todayValue(): number {
    return this.props.currentDayEntity.value;
  }
  get todayAverage(): number {
    return this.props.currentDayEntity.avg;
  }
  get todayAveragePercentage(): number {
    return 100 * this.todayAverage;
  }
  get average(): number {
    return this.props.entity.avg;
  }
  get targetValue(): number {
    return this.props.targetValue;
  }
  get deviation(): number {
    return this.todayAverage - this.targetValue;
  }
  public setSuccessPercentage(value: number): void {
    this._successPercentage = value;
  }
  get successPercentage(): number {
    return this._successPercentage;
  }
  setChallengeTargetOperator(operator: ChallengeTargetOperatorEnum): void {
    this._operator = operator;
  }
  get projectedSuccess(): boolean {
    return this._operator === ChallengeTargetOperatorEnum.MAX
      ? this.deviation <= 0
      : this.deviation >= 0;
  }
}
